import React from "react";
import i18n from "../../../i18n/i18n";
import {RouteComponentProps, withRouter} from "react-router";
import ActionForm from "../actionForm/actionForm";
import {observer} from "mobx-react";
import {RouteParamsModel} from "../../../common/models/routeParams";

class ModifyAction extends React.Component <RouteComponentProps> {
    public render(): JSX.Element {
        const params = this.props.match.params as RouteParamsModel;

        return (
            <div className="add-action content">
                <div className="header">
                    {i18n.t("timetable.actions.modifyAction.header")}
                </div>
                <div>
                    <ActionForm isUpdate={true} actionId={params.id}/>
                </div>
            </div>
        );
    }
}

export default withRouter(observer(ModifyAction));
